import { render, staticRenderFns } from "./CertificateManagement.vue?vue&type=template&id=705fa0cc"
import script from "./CertificateManagement.vue?vue&type=script&lang=js"
export * from "./CertificateManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports